import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import { get } from "../services/api";
import { PdfGenerator } from "../components/PdfGenerator/PdfGenerator";
import AdmissionChallanHtml from "../pages/admission/AdmissionChallanHtml";

const useAdmissionChallanPdf = () => {
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");

  const fetchChallanData = async (studentFirstRegistrationId) => {
    setLoading(true);
    try {
      const response = await get(
        `AssessmentType/GetAdmissionVoucherByRegistartionNoAsync?studentFirstRegistrationId=${studentFirstRegistrationId}&createdBy=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.isSuccess) {
        return response?.admissionVoucher;
      } else {
        throw new Error("Failed to fetch challan data.");
      }
    } catch (error) {
      console.error("Error fetching challan data:", error);
      throw error;
    }
  };

  const generatePDF = async (studentFirstRegistrationId) => {
    if (!studentFirstRegistrationId) {
      alert("Please enter registration number.");
      return;
    }

    setLoading(true);

    try {
      const challanData = await fetchChallanData(studentFirstRegistrationId);

      const container = document.createElement("div");
      container.style.position = "absolute";
      container.style.left = "-9999px";
      document.body.appendChild(container);

      const root = ReactDOM.createRoot(container);
      root.render(
        <div>
          <AdmissionChallanHtml challanData={challanData} />
        </div>
      );

      await new Promise((resolve) => setTimeout(resolve, 200));

      await PdfGenerator(container);

      root.unmount();
      document.body.removeChild(container);
    } catch (error) {
      console.error("Error generating PDF:", error);
      alert("Failed to generate PDF. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return { generatePDF, loading };
};

export default useAdmissionChallanPdf;
